module.exports = __webpack_public_path__ + "media/applicants/device_signup_5-au-14e8f739.jpg";